
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellleronrent() {



  const cardData =
  {
    keyword: 'Tempo Traveller on Rent in Pune',
    heading: 'AB Ghule Cabs: Tempo Traveller on Rent in Pune',
    headingDescription: 'AB Ghule Cabs provides reliable, comfortable, and affordable Tempo Traveller rental services in Pune. Whether you are planning a group trip, family outing, or a corporate event, our well-maintained Tempo Travellers are perfect for long-distance travel, local sightseeing, or airport transfers. With spacious interiors, modern amenities, and experienced drivers, we ensure a hassle-free and enjoyable journey for you and your group.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Tempo Traveller Rental in Pune',

    "topPlaces": [
  {
    title: "Spacious and Comfortable",
    description: "Our Tempo Travellers are equipped with comfortable seating, ample legroom, and air-conditioning, ensuring a relaxing journey for all passengers."
  },
  {
    title: "Affordable Pricing",
    description: "We offer competitive rates for both short-term and long-term rentals. Whether it's a one-day trip or a week-long tour, you will enjoy transparent and budget-friendly pricing."
  },
  {
    title: "Experienced Drivers",
    description: "Our professional drivers are well-trained to navigate through Pune's roads and ensure a safe and smooth ride. They are also familiar with popular tourist spots and can offer guidance during sightseeing tours."
  },
  {
    title: "Wide Range of Vehicles",
    description: "Choose from a variety of Tempo Traveller models, including 12-seater, 16-seater, and 20-seater vehicles, to accommodate your group size. Whether you're traveling with a small group or a large one, we have a suitable option for you."
  },
  {
    title: "24/7 Availability",
    description: "Our Tempo Traveller rental services are available round the clock. Whether you're planning a late-night trip or an early morning departure, we are here to serve you."
  },
  {
    title: "Customizable Packages",
    description: "We offer customizable packages for group tours, corporate events, airport transfers, or family outings. You can choose the duration, destinations, and services that best suit your needs."
  },
  {
    title: "Well-Maintained Vehicles",
    description: "All our Tempo Travellers are regularly serviced and maintained to ensure a smooth and trouble-free ride. Cleanliness and hygiene are also top priorities, and the vehicles are sanitized before every trip."
  },
  {
    title: "Tourist Sightseeing in Pune and Nearby Areas",
    description: "Our Tempo Travellers are perfect for sightseeing trips within Pune and surrounding areas like Lonavala, Mahabaleshwar, Sinhagad Fort, and more. Explore the beauty of Pune with ease and comfort."
  },
  {
    title: "Easy Booking Process",
    description: "Booking a Tempo Traveller with AB Ghule Cabs is simple and hassle-free. You can book your vehicle online or through a phone call, and our customer support team will assist you in customizing your trip."
  },
  {
    title: "No Hidden Charges",
    description: "We believe in transparency. The price you see at the time of booking is the price you pay, with no additional or hidden charges. Enjoy a straightforward and affordable rental experience with us."
  }
],


services: [
    {
      "name": "17 Seater Tempo Traveller on Rent in Pune",
      description: "AB Ghule Cabs offers a 17-seater tempo traveller for rent in Pune. Ideal for group trips, family outings, or corporate events, our well-maintained vehicles provide comfort and space for a smooth journey."
    },
    {
      "name": "13 Seater Tempo Traveller on Rent in Pune",
      description: "Looking for a 13-seater tempo traveller for rent in Pune? AB Ghule Cabs offers affordable options with reliable service, ensuring your group travels comfortably and safely to any destination."
    },
    {
      "name": "Traveller on Rent Pune",
      description: "AB Ghule Cabs offers a variety of traveller options for rent in Pune, including standard and luxury models, to accommodate both small and large groups. Our vehicles are perfect for local and outstation travel."
    },
    {
      "name": "Traveller Bus on Rent in Pune",
      description: "Need a bus on rent in Pune for a large group? AB Ghule Cabs offers traveller buses for rent, ensuring a comfortable and spacious journey for your group, whether it's for a short trip or an extended journey."
    },
    {
      "name": "17 Seater Bus Rate per Km in Pune",
      description: "AB Ghule Cabs provides competitive rates for renting a 17-seater bus in Pune. Our pricing is transparent, and the fare is calculated per kilometer to offer you flexibility and value for money."
    },
    {
      "name": "17 Seater Tempo Traveller in Pune",
      description: "Rent a 17-seater tempo traveller in Pune with AB Ghule Cabs. Our vehicles are equipped with modern amenities, offering a comfortable and smooth ride for group trips to various destinations."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent Pune",
      description: "AB Ghule Cabs offers 17-seater tempo travellers on rent in Pune, perfect for family outings, group tours, or corporate events. Enjoy a hassle-free and comfortable ride with our experienced drivers."
    },
    {
      "name": "20 Seater Tempo Traveller Pune",
      description: "For larger groups, AB Ghule Cabs provides a 20-seater tempo traveller for rent in Pune. Whether it's a family trip or a group tour, our vehicles ensure a spacious and comfortable journey."
    },
    {
      "name": "20 Seater Bus on Rent in Pune",
      description: "Rent a 20-seater bus from AB Ghule Cabs in Pune for your group travel. Our buses are spacious and ideal for longer trips, ensuring comfort and safety throughout the journey."
    },
    {
      "name": "25 Seater Bus Rate per Km Pune",
      description: "AB Ghule Cabs offers affordable rates for renting a 25-seater bus in Pune. The fare is calculated on a per-kilometer basis, making it easier for you to plan your travel costs for large group tours."
    },
    {
      "name": "AC Tempo Traveller on Rent in Pune",
      description: "AB Ghule Cabs provides AC tempo travellers on rent in Pune. Our air-conditioned vehicles ensure comfort, even on long journeys, making them the perfect choice for group travel in hot weather."
    },
    {
      "name": "Book Tempo Online Pune",
      description: "Booking a tempo traveller in Pune is easy with AB Ghule Cabs' online platform. You can quickly book your tempo rental, ensuring a smooth and convenient travel experience for your group."
    },
    {
      "name": "Book Tempo Traveller in Pune",
      description: "AB Ghule Cabs offers a seamless booking process for tempo travellers in Pune. Whether you need a vehicle for a local trip or an outstation journey, we have a variety of options to choose from."
    },
    {
      "name": "Hire Tempo in Pune",
      description: "Looking to hire a tempo in Pune? AB Ghule Cabs provides a variety of tempo travellers for hire, ensuring your group travels comfortably to any destination in Pune and beyond."
    },
    {
      "name": "Hire Tempo Traveller in Pune",
      description: "For group travel in Pune, hire a tempo traveller from AB Ghule Cabs. We offer flexible rental options, ensuring that your journey is both affordable and comfortable."
    },
    {
      "name": "Luxury Tempo Traveller on Rent in Pune",
      description: "AB Ghule Cabs offers luxury tempo travellers on rent in Pune. These vehicles come with premium features for a comfortable and relaxing journey, perfect for special occasions or corporate travel."
    },
    {
      "name": "Pune Tempo Traveller Hire for Outstation",
      description: "For outstation trips, hire a tempo traveller from Pune with AB Ghule Cabs. Our vehicles are well-maintained, providing a safe and comfortable ride for your long-distance travels."
    },
    {
      "name": "Pune to Mahabaleshwar Tempo Traveller",
      description: "Planning a trip to Mahabaleshwar? Book a tempo traveller from Pune with AB Ghule Cabs. Our vehicles are ideal for group trips to this popular hill station, ensuring a comfortable ride with plenty of space."
    },
    {
      "name": "Pune to Shirdi Tempo Traveller Rate",
      description: "AB Ghule Cabs offers affordable rates for hiring a tempo traveller from Pune to Shirdi. Whether it's a pilgrimage trip or a group visit, our services ensure timely arrival and comfort throughout the journey."
    },
    {
      "name": "Tempo Traveller Hire in Pune",
      description: "AB Ghule Cabs offers convenient tempo traveller hire services in Pune. With various vehicle options to choose from, we cater to group travel needs for local and outstation trips."
    },
    {
      "name": "Tempo Traveller on Rent in Pune Rate per Km",
      description: "The rates for tempo traveller rentals in Pune with AB Ghule Cabs are transparent and calculated on a per-kilometer basis. Enjoy flexible pricing with no hidden charges."
    },
    {
      "name": "Tempo Traveller Rental Pune",
      description: "AB Ghule Cabs provides tempo traveller rentals in Pune for group trips, corporate events, and other travel needs. Our well-maintained vehicles ensure comfort, safety, and punctuality."
    },
    {
      "name": "Tempo Traveller On Rent in Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient tempo traveller rental services. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["17 seater tempo traveller on rent in Pune", "- 13 seater tempo traveller on rent in Pune"],
    ["Traveller on rent Pune", "- Traveller bus on rent in Pune"],
    ["17 Seater Bus Rate per km in Pune", "- 17 Seater tempo traveller in Pune"],
    ["17 seater tempo traveller on rent Pune", "- 20 seater tempo traveller Pune"],
    ["20 seater bus on rent in Pune", "- 25 seater bus rate per km Pune"],
    ["AC tempo traveller on rent in Pune", "- Book tempo online Pune"],
    ["Book tempo traveller in Pune", "- Hire tempo in Pune"],
    ["Hire tempo traveller in Pune", "- Luxury tempo traveller on rent in Pune"],
    ["Pune Tempo Traveller hire for outstation", "- Pune to Mahabaleshwar tempo traveller"],
    ["Pune to Shirdi tempo traveller rate", "- Tempo Traveller hire in Pune"],
    ["Tempo traveller on rent in Pune rate per km", "- Tempo traveller rental Pune"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Spacious and Comfortable Vehicles",
      WhyChoosedescription: "Our Tempo Travellers are designed to provide maximum comfort and space for group travel. With ample seating, air conditioning, and generous legroom, you can enjoy a comfortable ride while traveling within Pune or for outstation trips."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our drivers are highly trained, experienced, and familiar with the routes to ensure a smooth and safe journey. They are courteous, professional, and dedicated to providing an excellent travel experience for you and your group."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "We take great care to maintain our fleet of Tempo Travellers, ensuring that they are regularly serviced and kept in pristine condition. Our vehicles undergo thorough inspections for safety, cleanliness, and comfort."
    },
    {
      WhyChooseheading: "Affordable Pricing",
      WhyChoosedescription: "We offer competitive pricing for our Tempo Traveller rentals, ensuring great value for your money. Our transparent pricing structure guarantees that there are no hidden charges, and you’ll know exactly what to expect."
    },
    {
      WhyChooseheading: "Customizable Travel Solutions",
      WhyChoosedescription: "Whether you need a Tempo Traveller for a family trip, corporate event, school excursion, or any other group travel, we offer flexible packages to suit your specific needs. We ensure that the travel experience is tailored to meet your preferences."
    },
    {
      WhyChooseheading: "Safety and Security",
      WhyChoosedescription: "Safety is a top priority for us. All our drivers are background-checked, and our vehicles are equipped with the latest safety features, including GPS, to ensure a safe and reliable journey."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We understand that travel needs can arise at any time. That’s why our Tempo Traveller services are available round the clock. Whether it's a last-minute trip or an early morning departure, we are always ready to assist."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking a Tempo Traveller with AB Ghule Cabs is quick and hassle-free. You can book online through our website or mobile app, or simply contact our customer service team for assistance."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Tempo Traveller in Pune?',
      answer: 'You can easily book a Tempo Traveller online via our website or app. Alternatively, you can call our customer service team to make a booking.',
    },
    {
      id: 'FAQ2',
      question: 'What types of Tempo Travellers are available?',
      answer: 'We offer various types of Tempo Travellers, including 12-seater, 16-seater, and 20-seater models, so you can choose the one that best suits your group size and preferences.',
    },
    {
      id: 'FAQ3',
      question: 'Is the Tempo Traveller air-conditioned?',
      answer: 'Yes, all our Tempo Travellers are equipped with air conditioning to ensure a comfortable ride, especially during long journeys.',
    },
    {
      id: 'FAQ4',
      question: 'How much does it cost to rent a Tempo Traveller in Pune?',
      answer: 'The rental cost depends on factors such as the duration of the trip, distance, and vehicle type. We offer affordable and transparent pricing with no hidden fees.',
    },
    {
      id: 'FAQ5',
      question: 'Are the drivers experienced and professional?',
      answer: 'Yes, all our drivers are experienced, professional, and familiar with the local routes. They are also background-checked for your safety and peace of mind.',
    },
    {
      id: 'FAQ6',
      question: 'Can I rent a Tempo Traveller for an outstation trip?',
      answer: 'Absolutely! We offer Tempo Traveller rentals for both local and outstation trips. Whether you\'re traveling within Pune or to nearby cities, we provide reliable and comfortable services.',
    },
    {
      id: 'FAQ7',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'There may be additional charges for waiting time or detours, depending on the nature of the trip. However, we ensure that all additional charges are communicated upfront.',
    },
    {
      id: 'FAQ8',
      question: 'How do I make payment for the rental?',
      answer: 'You can pay for the rental through multiple payment options, including cash, credit/debit cards, or online payment via our mobile app.',
    },
    {
      id: 'FAQ9',
      question: 'Is there a cancellation policy for Tempo Traveller rentals?',
      answer: 'Yes, we have a cancellation policy in place. Please contact our customer service team for specific details about cancellations or modifications to your booking.',
    },
    {
      id: 'FAQ10',
      question: 'Do you provide Tempo Travellers for corporate or group events?',
      answer: 'Yes, we provide Tempo Travellers for corporate events, group tours, school excursions, and other special occasions. We can customize the rental package according to your needs.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Rajesh Pawar',
      feedback: 'We rented a 16-seater Tempo Traveller for a family trip from Pune, and it was a fantastic experience. The vehicle was clean, spacious, and well-maintained, and the driver was very professional. The entire journey was comfortable and stress-free. Highly recommend AB Ghule Cabs!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Priya Deshmukh',
      feedback: 'I booked a Tempo Traveller for a corporate event in Pune, and the service was excellent. The vehicle was perfect for our group, and the driver was punctual and courteous. I will definitely use their services again for future events.',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Tempo Traveller on Rent in Pune | Affordable Travel Solutions | AB Ghule Cabs</title>
  <meta name="description" content="Affordable Tempo Traveller rental services in Pune. Offering 13, 17, 20, and 25 seater tempo travellers for outstation and local trips. Book online or call +91 8624029699." />
  <meta name="keywords" content="17 Seater Tempo Traveller on Rent in Pune, 13 Seater Tempo Traveller on Rent in Pune, Traveller on Rent Pune, Traveller Bus on Rent in Pune, 17 Seater Bus Rate per km in Pune, 17 Seater Tempo Traveller in Pune, 17 Seater Tempo Traveller on Rent Pune, 20 Seater Tempo Traveller Pune, 20 Seater Bus on Rent in Pune, 25 Seater Bus Rate per km Pune, AC Tempo Traveller on Rent in Pune, Book Tempo Online Pune, Book Tempo Traveller in Pune, Hire Tempo in Pune, Hire Tempo Traveller in Pune, Luxury Tempo Traveller on Rent in Pune, Pune Tempo Traveller Hire for Outstation, Pune to Mahabaleshwar Tempo Traveller, Pune to Shirdi Tempo Traveller Rate, Tempo Traveller Hire in Pune, Tempo Traveller on Rent in Pune Rate per km, Tempo Traveller Rental Pune" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Tempo Traveller on Rent in Pune | Affordable Travel Solutions | AB Ghule Cabs" />
  <meta property="og:description" content="Affordable Tempo Traveller rental services in Pune. Offering 13, 17, 20, and 25 seater tempo travellers for outstation and local trips. Book online or call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/tempo-traveller-rent.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/tempo-traveller-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Tempo Traveller on Rent in Pune",
        description: "Affordable Tempo Traveller rental services in Pune. Offering 13, 17, 20, and 25 seater tempo travellers for outstation and local trips. Book online or call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/tempo-traveller-on-rent-in-pune",
        "logo": "https://abghulecabs.com/images/tempo-traveller-rent.jpg",
        "image": "https://abghulecabs.com/images/tempo-traveller-rent.jpg",
        "priceRange": "₹1500 - ₹6000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/tempo-traveller-on-rent-in-pune",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "150"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Shubham R"
            },
            "datePublished": "2024-10-15",
            "reviewBody": "Very comfortable and affordable Tempo Traveller service. Highly recommend for outstation trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya S"
            },
            "datePublished": "2024-08-30",
            "reviewBody": "Great experience with AB Ghule Cabs. The driver was very polite, and the tempo was spacious and clean."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Tempo Traveller Rentals",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/tempo-traveller-on-rent-in-pune"
        },
        "keywords": "17 Seater Tempo Traveller on Rent in Pune, 13 Seater Tempo Traveller on Rent in Pune, Traveller on Rent Pune, Traveller Bus on Rent in Pune, 17 Seater Bus Rate per km in Pune, 17 Seater Tempo Traveller in Pune, 17 Seater Tempo Traveller on Rent Pune, 20 Seater Tempo Traveller Pune, 20 Seater Bus on Rent in Pune, 25 Seater Bus Rate per km Pune, AC Tempo Traveller on Rent in Pune, Book Tempo Online Pune, Book Tempo Traveller in Pune, Hire Tempo in Pune, Hire Tempo Traveller in Pune, Luxury Tempo Traveller on Rent in Pune, Pune Tempo Traveller Hire for Outstation, Pune to Mahabaleshwar Tempo Traveller, Pune to Shirdi Tempo Traveller Rate, Tempo Traveller Hire in Pune, Tempo Traveller on Rent in Pune Rate per km, Tempo Traveller Rental Pune"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/38.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Tempotravellleronrent;